<template>
  <div>
    <div class="doctors-cards__item-calendar">
      <div class="doctors-cards__group-all" :style="isDetailsPage">
        <div class="doctorts-cards__calendar-top">
          <div class="doctors-cards__column">
            <div
              class="doctors-cards__column-item doctors-cards__column-item--arrow"
              @click="moreDays('prev')"
            >
              <img src="./../assets/images/arrow-left-icon.svg" alt="" />
            </div>
          </div>

          <div class="doctors-cards__column">
            <div class="doctors-cards__column-group">
              <div
                v-for="(day, index) in pagination"
                class="doctors-cards__column-group-item"
                :key="index"
              >
                <div class="doctors-cards__top">
                  <span class="doctors-cards__top-day">
                    {{ theWeekDay(day.slot_date) }}
                  </span>
                  <div class="doctors-cards__top-date">
                    {{ theDate(day.slot_date) }}
                  </div>
                </div>

                <div class="doctors-cards__middle">
                  <span
                    v-for="(slot, idx) in day.slots"
                    :key="idx"
                    class="doctors-cards__middle-date"
                    @click="schedule(slot.hour, slot.slot_date, slot.slot_id)"
                  >
                    {{ slot.hour }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="doctors-cards__column">
            <div
              class="doctors-cards__column-item doctors-cards__column-item--arrow"
              @click="moreDays('next')"
            >
              <img src="./../assets/images/arrow-right-icon.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="doctorts-cards__calendar-bottom">
          <p class="doctorts-cards__view-more" @click="showMore = !showMore">
            {{ !showMore ? "Exibir mais" : "Exibir menos" }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  userMethods,
  userComputed,
  authComputed,
  doctorMethods,
  appointmentsMethods
} from "./../state/helpers";
import { formatDate, formatWeekDay } from "../utils/masks/formatSlotDate";

export default {
  name: "TimeTable",
  props: { doctor: { type: Object, default: null } },
  data() {
    return {
      currentPage: 0,
      showMore: false,
      availables: []
    };
  },

  mounted() {
    this.fetchDoctorsAvailables({ id: this.doctor.id }).then(
      response => {
        this.availables = response.data.filter(available => available.id)
      }
    );
  },

  methods: {
    ...userMethods,
    ...doctorMethods,
    ...appointmentsMethods,
    moreDays(action) {
      if (action === "prev" && this.currentPage > 0) {
        return this.currentPage--;
      }
      if (action === "next" && this.currentPage < this.getMaxPage) {
        return this.currentPage++;
      }
    },
    loginOrCreate(urlName) {
      this.$router.push({ name: urlName });
    },
    schedule(hour, date, id) {
      this.holdScheduleAppointment({
        scheduled_at: `${date} ${hour}:00`,
        scheduled_until: `${date} 00:00:00`,
        doctor: this.doctor,
        slot_date: date,
        slot_hour: hour,
        slot_id: id
      });
      if (this.loggedIn) {
        this.$router.push({ name: "Schedule" });
      } else {
        this.$bvModal.show("loginOrRegistration");
      }
    },

    verifyAuth() {
      if (!this.currentUser) return this.$router.push({ name: "Login" });
    },
    doctorHasAvailability(page) {
      return this.availables && this.availables[page];
    },
    listAvailableHours(availableHours) {
      return !this.showMore ? availableHours.slice(0, 4) : availableHours;
    },

    theWeekDay(value) {
      return formatWeekDay(value);
    },

    theDate(value) {
      return formatDate(value);
    }
  },

  computed: {
    ...authComputed,
    ...userComputed,
    isDetailsPage() {
      if (this.$route.name != "Site")
        return `background-color: #fff;
                padding: 2em;
                box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
                border-radius: 8px;
                position: sticky;
                top: 20px;`;

      return "";
    },
    listAvailableDays() {
      let reduced = this.availables.reduce((prevValue, currentValue) => {
        prevValue[currentValue.slot_date] = [
          ...(prevValue[currentValue.slot_date] || []),
          ...currentValue.slots.map(slot => ({
            slot_id: currentValue.id,
            slot_date: currentValue.slot_date,
            hour: slot
          }))
        ];
        return prevValue;
      }, {});
      return reduced;
    },
    pagination() {
      let pages = [];
      let reduced = this.listAvailableDays;
      Object.keys(reduced)
        .slice(this.currentPage * 4, this.currentPage * 4 + 4)
        .filter(day => {
          if (reduced[day]) {
            pages.push({
              slots: this.listAvailableHours(reduced[day]),
              slot_date: day
            });
          }
        });
      return pages;
    },
    getMaxPage() {
      return Math.ceil(Object.keys(this.listAvailableDays).length / 4) - 1;
    }
  }
};
</script>

<style></style>
